import { api } from "@/lib/api-client";

/** A document awaiting image purge (still in retention window). */
export interface AwaitingPurgeItem {
  id: string;
  displayId: string;
  filename: string;
  jobTypeId: string;
  jobTypeName: string | null;
  retentionExpiresAt: string;
  minutesRemaining: number;
  thumbnailPath: string | null;
}

/** A document whose images have already been purged. */
export interface PurgedItem {
  id: string;
  displayId: string;
  filename: string;
  jobTypeId: string;
  jobTypeName: string | null;
  imagesPurgedAt: string;
}

export type HistoryFilter = "awaiting_purge" | "purged";
export type HistoryItem = AwaitingPurgeItem | PurgedItem;

interface HistoryResponse {
  items: HistoryItem[];
}

export function getHistory(filter: HistoryFilter): Promise<HistoryItem[]> {
  return api
    .get<HistoryResponse>(`/history?filter=${filter}`)
    .then((r) => r.items);
}

/** Delete images for a document immediately (mirrors retention client's purgeNow). */
export function purgeNow(id: string): Promise<void> {
  return api.post(`/documents/${id}/purge`, {});
}

export type ReprocessTargetStep = "scan" | "key" | "verify" | "qc" | "export";

/** Re-process a document from a specific pipeline step. */
export function reprocessDoc(id: string, targetStep: ReprocessTargetStep): Promise<void> {
  return api.post(`/documents/${id}/reprocess`, { targetStep });
}
